import React from 'react'

export default function BonusDrawInfo({ children }) {
  return <div className='bonus-draw__info'>{children}</div>;
}
